export default {
  badge: 'バッジ',
  open: '開く',
  close: '閉じる',
  dismiss: '閉じる',
  confirmEdit: {
    ok: 'OK',
    cancel: 'キャンセル',
  },
  dataIterator: {
    noResultsText: '検索結果が見つかりません。',
    loadingText: '項目をロード中です...',
  },
  dataTable: {
    itemsPerPageText: '1ページあたりの行数：',
    ariaLabel: {
      sortDescending: '降順の並び替え。',
      sortAscending: '昇順の並び替え。',
      sortNone: 'ソートされていません。',
      activateNone: 'ソートを削除するには有効にしてください。',
      activateDescending: '降順の並び替えのためには有効にしてください。',
      activateAscending: '昇順のソートのためには有効にしてください。',
      selectRow: '行を選択',
      selectAll: 'すべて選択',
      selectGroup: 'グループを選択',
    },
    sortBy: 'ソート方式',
  },
  dataFooter: {
    itemsPerPageText: '1ページあたりの件数：',
    itemsPerPageAll: 'すべて',
    nextPage: '次のページ',
    prevPage: '前のページ',
    firstPage: '最初のページ',
    lastPage: '最後のページ',
    pageText: '{0}-{1} 件目 / {2}件',
  },
  dateRangeInput: {
    divider: 'から',
  },
  monthPicker: {
    title: '月を選択',
    itemsSelected: '{0} 選択済',
    header: '月を入力',
    range: {
      title: '月を入力',
    },
    ariaLabel: {
      previousYear: '前の年',
      nextYear: '次の年',
      selectYear: '年を選択',
      currentMonth: '今月、{0}',
    },
  },
  datePicker: {
    itemsSelected: '{0} 選択済',
    range: {
      title: '日付を選択',
      header: '日付を入力',
    },
    title: '日付を選択',
    header: '日付を入力',
    input: {
      placeholder: '日付を入力',
    },
    ariaLabel: {
      previousMonth: '前の月',
      nextMonth: '次の月',
      selectYear: '年を選択',
      previousYear: '前の年',
      nextYear: '次の年',
      selectMonth: '月を選択',
      selectDate: '{0}',
      currentDate: '今日、{0}',
    },
  },
  noDataText: 'データはありません。',
  carousel: {
    prev: '前のビジュアル',
    next: '次のビジュアル',
    ariaLabel: {
      delimiter: 'カルーセルのスライド {0}件目 / {1}件',
    },
  },
  calendar: {
    moreEvents: 'さらに{0}',
    today: '今日',
  },
  heatmap: {
    less: '少ない',
    more: '多い',
  },
  input: {
    clear: 'クリア {0}',
    prependAction: '{0} の前に追加されたアクション',
    appendAction: '{0} の後に追加されたアクション',
    otp: '{0}番目のワンタイムパスワードを入力してください',
  },
  fileInput: {
    counter: '{0} ファイル',
    counterSize: '{0} ファイル (合計 {1})',
  },
  fileUpload: {
    title: 'ここにファイルをドラッグ＆ドロップ',
    divider: 'または',
    browse: 'ファイルを選択',
  },
  timePicker: {
    am: '午前',
    pm: '午後',
    title: '時間を選択',
    hour: '時',
    minute: '分',
    second: '秒',
    notAllowed: '値は許可されていません',
  },
  pagination: {
    ariaLabel: {
      root: 'ページネーションナビゲーション',
      next: '次のページ',
      previous: '前のページ',
      page: '{0}ページ目に移動',
      currentPage: '現在のページ、ページ {0}',
      first: '最初のページ',
      last: '最後のページ',
    },
  },
  stepper: {
    next: '次へ',
    prev: '前へ',
  },
  rating: {
    ariaLabel: {
      item: '評価 {1} のうち {0}',
    },
  },
  loading: 'ロード中...',
  infiniteScroll: {
    loadMore: 'さらに読み込む',
    empty: 'データがありません',
  },
  rules: {
    required: 'このフィールドは必須です',
    email: '有効なメールアドレスを入力してください',
    number: 'このフィールドには数字のみ入力できます',
    integer: 'このフィールドには整数のみ入力できます',
    capital: 'このフィールドには大文字のみ入力できます',
    maxLength: '最大{0}文字まで入力してください',
    minLength: '最低{0}文字以上入力してください',
    strictLength: '入力されたフィールドの長さが無効です',
    exclude: '{0}という文字は使用できません',
    notEmpty: '少なくとも1つの値を選んでください',
    pattern: '無効な形式です',
  },
  command: {
    search: 'コマンドを入力するか検索...',
  },
  hotkey: {
    then: '次に',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: '上矢印',
    downArrow: '下矢印',
    leftArrow: '左矢印',
    rightArrow: '右矢印',
    backspace: 'バックスペース',
    space: 'スペース',
    plus: 'プラス',
    shortcut: 'キーボードショートカット: {0}',
    or: 'または',
  },
  video: {
    play: '再生',
    pause: '一時停止',
    seek: 'シーク',
    volume: '音量',
    showVolume: '音量コントロールを表示',
    mute: 'ミュート',
    unmute: 'ミュート解除',
    enterFullscreen: '全画面表示',
    exitFullscreen: '全画面表示を終了',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: '画面から色を選択',
      hueSlider: '色相',
      alphaSlider: 'アルファ',
      redInput: '赤',
      greenInput: '緑',
      blueInput: '青',
      alphaInput: 'アルファ',
      hueInput: '色相',
      saturationInput: '彩度',
      lightnessInput: '明度',
      hexInput: 'HEX値',
      hexaInput: 'アルファ付きHEX値',
      changeFormat: 'カラーフォーマットを変更',
    },
  },
}
